<app-styled-banner [banner]='banner'></app-styled-banner>
<app-residencies></app-residencies>
